module.exports = __webpack_public_path__ + "img/xingbake_1.8d663ed6.png";